import styled from 'styled-components';

const CarouselImageWrapper = styled.div`
  min-width: 0;
  position: relative;
`;

export default CarouselImageWrapper;
